import React from 'react';
import PropTypes from 'prop-types';
import BodyContentLayout from '../layout/BodyContentLayout';
import LeftContentLayout from '../layout/LeftContentLayout';
import RightContentLayout from '../layout/RightContentLayout';
import DailyVideoItem from './DailyVideoItem';
import AssignAllVideos from 'chameleon-packages/units/components/actions/AssignAllVideos';

const DailyVideos = ({
  items,
  title,
  label,
  showIcon,
  unitNumber,
  subjectData,
  assignAllVideos,
  subunitTitle,
  subunitLabel,
  unitTitle,
  userData: { isStudent },
}) => (
  <BodyContentLayout>
    <RightContentLayout
      title={title}
      showIcon={showIcon}
      label={label}
      icon="play_circle"
    >
      {assignAllVideos && !isStudent && (
        <AssignAllVideos
          containerClasses="ml-32"
          items={items}
          unitTitle={unitTitle}
          subunitTitle={subunitTitle}
          subunitLabel={subunitLabel}
          unitNumber={unitNumber}
          context="subunit"
        />
      )}
    </RightContentLayout>

    {items && (
      <LeftContentLayout>
        {items &&
          items.map((item) => (
            <DailyVideoItem
              unitNumber={unitNumber}
              key={item.id}
              item={item}
              subjectData={subjectData}
            />
          ))}
      </LeftContentLayout>
    )}
  </BodyContentLayout>
);

DailyVideos.propTypes = {
  title: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  items: PropTypes.array.isRequired,
  showIcon: PropTypes.bool,
  subjectData: PropTypes.oneOfType([PropTypes.object, PropTypes.bool])
    .isRequired,
  assignAllVideos: PropTypes.bool.isRequired,
  subunitTitle: PropTypes.string.isRequired,
  subunitLabel: PropTypes.string.isRequired,
  unitTitle: PropTypes.string.isRequired,
  userData: PropTypes.object,
};

DailyVideos.defaultProps = {
  title: 'AP Daily Videos',
  label: '',
  showIcon: true,
  userData: {
    isStudent: false,
  },
};

export default DailyVideos;
